"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$sharedState = exports.initialSharedStateValue = void 0;
const ramda_1 = require("ramda");
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const events_1 = require("./events");
const constants_1 = require("./constants");
const extraSmallViewportMql = window.matchMedia(`(any-pointer: coarse) and (max-width: ${wl_ui_kit_1.VIEWPORT_BREAKPOINTS.EXTRA_SMALL}px)`);
const smallViewportMql = window.matchMedia(`(any-pointer: coarse) and (max-width: ${wl_ui_kit_1.VIEWPORT_BREAKPOINTS.SMALL}px)`);
const mediumViewportMql = window.matchMedia(`(any-pointer: coarse) and (max-width: ${wl_ui_kit_1.VIEWPORT_BREAKPOINTS.MEDIUM}px)`);
exports.initialSharedStateValue = {
    extraSmallViewport: extraSmallViewportMql.matches,
    smallViewport: smallViewportMql.matches,
    mediumViewport: mediumViewportMql.matches,
    // NOTE: mobileResolution is deprecated
    mobileResolution: smallViewportMql.matches
};
exports.$sharedState = constants_1.sharedStateDomain.createStore(exports.initialSharedStateValue, {
    name: `${constants_1.domainKey}/stores/sharedState`,
    sid: `${constants_1.domainKey}/stores/sharedState`
});
exports.$sharedState.on(events_1.shareValue, (state, payload) => {
    const { storePath, sharedValue } = payload;
    return (0, ramda_1.assocPath)(storePath, sharedValue, state);
});
exports.$sharedState.on(events_1.deleteSharedValue, (state, path) => {
    return (0, ramda_1.dissocPath)(path, state);
});
extraSmallViewportMql.addEventListener('change', (event) => {
    (0, events_1.shareValue)({
        storePath: ['extraSmallViewport'],
        sharedValue: event.matches
    });
});
smallViewportMql.addEventListener('change', (event) => {
    (0, events_1.shareValue)({
        storePath: ['smallViewport'],
        sharedValue: event.matches
    });
    (0, events_1.shareValue)({
        storePath: ['mobileResolution'],
        sharedValue: event.matches
    });
});
mediumViewportMql.addEventListener('change', (event) => {
    (0, events_1.shareValue)({
        storePath: ['mediumViewport'],
        sharedValue: event.matches
    });
});
